const GLOBALLY_EXCLUDED_CLICKER_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[globallyExcludedClickerManagementExperience] createGloballyExcludedClicker',
  DELETE: '[globallyExcludedClickerManagementExperience] deleteGloballyExcludedClicker'
}

export default GLOBALLY_EXCLUDED_CLICKER_MANAGEMENT_EXPERIENCE_TYPES
